import { CreateAccount as CreateAccountComponent } from 'features/CreateAccount';

const CreateAccount = (): JSX.Element => {
	return <CreateAccountComponent />;
};
export default CreateAccount;
